// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import CostCategoryToggleController from "./cost_category_toggle_controller"
application.register("cost-category-toggle", CostCategoryToggleController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import MaterialAutocompleteController from "./material_autocomplete_controller"
application.register("material-autocomplete", MaterialAutocompleteController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import PaymentBatchFormController from "./payment_batch_form_controller"
application.register("payment-batch-form", PaymentBatchFormController)

import PaymentBatchPickerController from "./payment_batch_picker_controller"
application.register("payment-batch-picker", PaymentBatchPickerController)

import RecordAutocompleteController from "./record_autocomplete_controller"
application.register("record-autocomplete", RecordAutocompleteController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import UserAutocompleteController from "./user_autocomplete_controller"
application.register("user-autocomplete", UserAutocompleteController)

import VendorPickerController from "./vendor_picker_controller"
application.register("vendor-picker", VendorPickerController)
